import React from 'react';
import { Divider, Avatar, List, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import UserService from '../../../services/UserService';
import packageJson from '../../../../package.json';
import { useTranslation } from 'react-i18next';

export default function MiniProfile({ username, setMiniprofileOpen }) {
    let navigate = useNavigate();
    let role = UserService.role();
    const { t } = useTranslation();

    const data = [
        {
            title: t('common.ChangePassword'),
            icon: (
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.00009 0.470581C5.64715 0.470581 3.76479 2.35293 3.76479 4.70587V6.58823C2.96479 6.58823 2.35303 7.19999 2.35303 7.99999V14.1176C2.35303 14.9176 2.96479 15.5294 3.76479 15.5294H12.2354C13.0354 15.5294 13.6472 14.9176 13.6472 14.1176V7.99999C13.6472 7.19999 13.0354 6.58823 12.2354 6.58823V4.70587C12.2354 2.35293 10.353 0.470581 8.00009 0.470581ZM12.706 7.99999V14.1176C12.706 14.4 12.5177 14.5882 12.2354 14.5882H3.76479C3.48244 14.5882 3.2942 14.4 3.2942 14.1176V7.99999C3.2942 7.71764 3.48244 7.5294 3.76479 7.5294H4.23538H11.7648H12.2354C12.5177 7.5294 12.706 7.71764 12.706 7.99999ZM4.70597 6.58823V4.70587C4.70597 2.87058 6.16479 1.41176 8.00009 1.41176C9.83538 1.41176 11.2942 2.87058 11.2942 4.70587V6.58823H4.70597Z"
                        fill="#7B67FB"
                    />
                    <path
                        d="M8.00014 8.94116C7.20014 8.94116 6.58838 9.55293 6.58838 10.3529C6.58838 10.9647 6.96485 11.4823 7.52955 11.6706V12.7059C7.52955 12.9882 7.71779 13.1765 8.00014 13.1765C8.28249 13.1765 8.47073 12.9882 8.47073 12.7059V11.6706C9.03543 11.4823 9.4119 10.9647 9.4119 10.3529C9.4119 9.55293 8.80014 8.94116 8.00014 8.94116ZM8.00014 10.8235C7.71779 10.8235 7.52955 10.6353 7.52955 10.3529C7.52955 10.0706 7.71779 9.88234 8.00014 9.88234C8.28249 9.88234 8.47073 10.0706 8.47073 10.3529C8.47073 10.6353 8.28249 10.8235 8.00014 10.8235Z"
                        fill="#7B67FB"
                    />
                </svg>
            ),
            path: '/changepassword',
        },
    ];
    return (
        <div style={{ padding: '12px 16px', minWidth: '320px' }}>
            <div className="grid grid-cols-1">
                <div className="mx-auto pt-4">
                    <svg
                        width="84"
                        height="84"
                        viewBox="0 0 84 84"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle
                            cx="42"
                            cy="42"
                            r="40.0229"
                            stroke="#F5F6FF"
                            strokeWidth="3.95425"
                        />
                        <mask id="path-2-inside-1_2383_137237" fill="white">
                            <path d="M68.8569 72.6047C69.324 73.1369 69.2722 73.9488 68.726 74.3994C62.0601 79.8982 53.8505 83.214 45.2139 83.8769C36.1506 84.5724 27.1062 82.3088 19.439 77.426C11.7718 72.5432 5.8957 65.3047 2.69309 56.7975C-0.509513 48.2904 -0.865726 38.9739 1.67795 30.247C4.22163 21.5202 9.52788 13.8541 16.7999 8.40011C24.0718 2.94609 32.917 -0.00150359 42.0069 5.75017e-07C51.0969 0.00150474 59.9411 2.95202 67.2113 8.40845C74.1391 13.608 79.2814 20.8155 81.9488 29.0348C82.1674 29.7083 81.7748 30.4208 81.0948 30.6188V30.6188C80.4149 30.8167 79.7053 30.4251 79.4853 29.7519C76.974 22.0655 72.1559 15.3258 65.6719 10.4595C58.8457 5.3362 50.5415 2.56584 42.0065 2.56442C33.4715 2.56301 25.1665 5.33063 18.3385 10.4516C11.5106 15.5727 6.52829 22.7706 4.13992 30.9646C1.75156 39.1586 2.08602 47.9063 5.09308 55.894C8.10014 63.8817 13.6175 70.6783 20.8165 75.263C28.0156 79.8477 36.5077 81.9731 45.0177 81.3199C53.1009 80.6996 60.7857 77.6042 67.0337 72.4709C67.5809 72.0214 68.3898 72.0724 68.8569 72.6047V72.6047Z" />
                        </mask>
                        <path
                            d="M68.8569 72.6047C69.324 73.1369 69.2722 73.9488 68.726 74.3994C62.0601 79.8982 53.8505 83.214 45.2139 83.8769C36.1506 84.5724 27.1062 82.3088 19.439 77.426C11.7718 72.5432 5.8957 65.3047 2.69309 56.7975C-0.509513 48.2904 -0.865726 38.9739 1.67795 30.247C4.22163 21.5202 9.52788 13.8541 16.7999 8.40011C24.0718 2.94609 32.917 -0.00150359 42.0069 5.75017e-07C51.0969 0.00150474 59.9411 2.95202 67.2113 8.40845C74.1391 13.608 79.2814 20.8155 81.9488 29.0348C82.1674 29.7083 81.7748 30.4208 81.0948 30.6188V30.6188C80.4149 30.8167 79.7053 30.4251 79.4853 29.7519C76.974 22.0655 72.1559 15.3258 65.6719 10.4595C58.8457 5.3362 50.5415 2.56584 42.0065 2.56442C33.4715 2.56301 25.1665 5.33063 18.3385 10.4516C11.5106 15.5727 6.52829 22.7706 4.13992 30.9646C1.75156 39.1586 2.08602 47.9063 5.09308 55.894C8.10014 63.8817 13.6175 70.6783 20.8165 75.263C28.0156 79.8477 36.5077 81.9731 45.0177 81.3199C53.1009 80.6996 60.7857 77.6042 67.0337 72.4709C67.5809 72.0214 68.3898 72.0724 68.8569 72.6047V72.6047Z"
                            stroke="url(#paint0_linear_2383_137237)"
                            strokeWidth="9.4902"
                            mask="url(#path-2-inside-1_2383_137237)"
                        />

                        <circle cx="42" cy="42" r="35" fill="#EEE5FF" />
                        <text
                            style={{
                                shapeRendering: 'geometricPrecision',
                                textRendering: 'geometricPrecision',
                                imageRendering: 'optimizeQuality',
                                fillRule: 'evenodd',
                                clipRule: 'evenodd',
                            }}
                            className="font-[400] text-[40px] text-[#7B67FB] text-center"
                            x="50%"
                            y="50%"
                            text-anchor="middle"
                            fill="#7B67FB"
                            dy=".3em"
                        >
                            {username ? username[0] : ''}
                        </text>

                        <defs>
                            <linearGradient
                                id="paint0_linear_2383_137237"
                                x1="42"
                                y1="0"
                                x2="42"
                                y2="84"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#121330" />
                                <stop offset="0.145833" stop-color="#5F44CF" />
                                <stop offset="1" stop-color="#9038EA" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div className="pt-2 pb-4">
                    <div className="font-semibold text-center">
                        {username ? username : ''}
                    </div>
                    <div className="text-center text-xs font-normal text-[#808080]">
                        {role}
                    </div>
                </div>
                <div>
                    <Divider className="m-0"></Divider>
                    <List
                        itemLayout="horizontal"
                        dataSource={data}
                        renderItem={(item) => (
                            <List.Item
                                onClick={() => {
                                    setMiniprofileOpen(false);
                                    navigate(item.path);
                                }}
                                className="section px-2 duration-300 cursor-pointer"
                            >
                                <List.Item.Meta
                                    style={{ alignItems: 'inherit' }}
                                    avatar={
                                        <Avatar
                                            className="rounded-lg duration-300 avatar-mini"
                                            shape="square"
                                            size="large"
                                            icon={item.icon}
                                        />
                                    }
                                    title={
                                        <div className="py-auto align-middle inline-block">
                                            {item.title}
                                        </div>
                                    }
                                />
                            </List.Item>
                        )}
                    />
                    <Divider className="m-0"></Divider>
                </div>
                <div className="pt-8 text-center">
                    <Button
                        className="border-purple text-purple"
                        onClick={() => {
                            UserService.doLogout();
                            localStorage.clear();
                        }}
                        size="large"
                    >
                        {t('Sign out')}
                    </Button>
                    <div className="text-10 pt-2">V.{packageJson.version}</div>
                </div>
            </div>
        </div>
    );
}
